var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderPaymentFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2933_6121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5616 45.2906L5.16663 53.6667V9.39316C5.16663 8.75846 5.41246 8.14975 5.85004 7.70094C6.28763 7.25214 6.88112 7 7.49996 7H49.5C50.1188 7 50.7123 7.25214 51.1499 7.70094C51.5875 8.14975 51.8333 8.75846 51.8333 9.39316V42.8974C51.8333 43.5321 51.5875 44.1409 51.1499 44.5897C50.7123 45.0385 50.1188 45.2906 49.5 45.2906H15.5616ZM26.8503 28.828L21.0753 22.905L17.776 26.2913L26.8503 35.5983L40.05 22.0602L36.7506 18.6762L26.8503 28.828Z",
    fill: "#4D33EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2933_6121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPaymentFill);
export default __webpack_public_path__ + "static/media/OrderPayment-fill.b077a928dfe9c2fa23f0e770fd9dd640.svg";
export { ForwardRef as ReactComponent };